import JourneySimpleTablev2 from "./JourneyTablev2";

export default JourneySimpleTablev2;
